import React from 'react';
import PropTypes from 'prop-types';

const Label = (props) => {
  const { name, title, errors } = props;
  const error = errors[name];
  return (
    <label name={name} htmlFor={name}>
      {title}
      {error && <span className="input-error">{error}</span>}
    </label>
  );
};

export default Label;

Label.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  errors: PropTypes.shape(),
};

Label.defaultProps = {
  errors: {},
};
